import { ParsedCartItemGroup } from 'ui/types/cartTypes';
import {
  getExtensionMonthsFromCart,
  getMembershipInCart,
  getMembershipTierFromCart,
} from '@/components/Cart/cart.utils';
import { JOIN_FLOW_ROUTES, UPGRADE_ROUTES } from '@/utils/getCurrentPage';

export const getOrderPageUrl = ({
  isUpgradeFlow,
  cartItemGroups,
}: {
  isUpgradeFlow: boolean;
  cartItemGroups: ParsedCartItemGroup[];
}): string => {
  if (isUpgradeFlow) {
    const tier = getMembershipTierFromCart(cartItemGroups);
    const months = getExtensionMonthsFromCart(cartItemGroups);
    const queryParams = new URLSearchParams();
    if (tier) {
      queryParams.set('tier', tier.toString());
    }
    if (months) {
      queryParams.set('months', months.toString());
    }
    return `${UPGRADE_ROUTES.ORDER}?${queryParams.toString()}`;
  }

  return JOIN_FLOW_ROUTES.ORDER;
};

export const getAccessoriesPageUrl = ({
  isUpgradeFlow,
  cartItemGroups,
}: {
  isUpgradeFlow: boolean;
  cartItemGroups: ParsedCartItemGroup[];
}): string => {
  if (isUpgradeFlow) {
    const tier = getMembershipTierFromCart(cartItemGroups);
    const queryParams = new URLSearchParams();
    if (tier) {
      queryParams.set('tier', tier.toString());
    }
    return `${UPGRADE_ROUTES.ACCESSORIES}?${queryParams.toString()}`;
  }
  // If trial is in cart, set tier to trial in url so 4.0 accessories are returned on accessories page
  const membershipInCart = getMembershipInCart(cartItemGroups);
  if (membershipInCart) {
    const tier = getMembershipTierFromCart(cartItemGroups);
    const queryParams = new URLSearchParams();
    if (tier) {
      queryParams.set('tier', tier.toString());
    }
    return `${JOIN_FLOW_ROUTES.ACCESSORIES}?${queryParams.toString()}`;
  }

  return `${JOIN_FLOW_ROUTES.ACCESSORIES}${window.location.search}`;
};

export const getMembershipPageUrl = (
  cartItemGroups: ParsedCartItemGroup[],
): string => {
  const tier = getMembershipTierFromCart(cartItemGroups);
  const queryParams = new URLSearchParams();
  if (tier) {
    queryParams.set('tier', tier.toString());
  }
  return `${JOIN_FLOW_ROUTES.MEMBERSHIP}?${queryParams.toString()}`;
};
